import { lazy, Suspense } from 'react';
import { Route } from 'react-router';
import { learningRoutePaths } from 'core/lib/routePaths/learningRoutePaths';
import { RouteLoader } from '#components/Loader/RouteLoader';

const Learning = lazy(() => import('learning/central-routes/learning-routes'));

const LearningIndex = lazy(() =>
  import('learning/central-routes/learning-routes').then((module) => ({
    default: module.LearningIndex,
  })),
);

const Courses = lazy(() =>
  import('learning/central-routes/learning-routes').then((module) => ({
    default: module.CoursesRoute,
  })),
);

const Admin = lazy(() =>
  import('learning/central-routes/learning-routes').then((module) => ({
    default: module.AdminRoute,
  })),
);

const Checkout = lazy(() =>
  import('learning/central-routes/learning-routes').then((module) => ({
    default: module.CheckoutRoute,
  })),
);

const CourseDetails = lazy(() =>
  import('learning/central-routes/learning-routes').then((module) => ({
    default: module.CourseDetailsRoute,
  })),
);

const PurchaseConfirmation = lazy(() =>
  import('learning/central-routes/learning-routes').then((module) => ({
    default: module.PurchaseConfirmationRoute,
  })),
);

export const LearningRouteTree = (
  <Route
    path={learningRoutePaths.HOME}
    element={
      <Suspense fallback={<RouteLoader />}>
        <Learning />
      </Suspense>
    }
  >
    <Route index element={<LearningIndex />} />
    <Route path="courses" element={<Courses />} />
    <Route path="courses/:courseId" element={<CourseDetails />} />
    <Route path="courses/:courseId/prices" element={<CourseDetails />} />
    <Route path="admin" element={<Admin />} />
    <Route path="checkout/:course" element={<Checkout />} />
    <Route path="checkout/:course/:step" element={<Checkout />} />
    <Route path="checkout/:course/:step/:qty" element={<Checkout />} />
    <Route path="confirmation/:id" element={<PurchaseConfirmation />} />
  </Route>
);

export const preloadLearning = () => {
  void import('learning/central-routes/learning-routes');
};
